import {
  Grid,
  Box,
  TablePagination,
  TextField,
  Button,
  ButtonGroup,
  Typography,
} from "@mui/material";
import StatisticsPage from "./components/team_by_event/statistics";
import OverviewPage from "./components/team_by_event/overview";
import MatchesPage from "./components/team_by_event/matches";
import * as React from "react";
import { useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../../themes/themes";
import { useNavigate } from "react-router-dom";
import QuickSearch from "../../components/analysis/quickSearch";
import { useGlobal } from "../../context/GlobalProvider";

export default function TeamAnalysisByEvent({ user, signOut }) {
  const { targetAnalysisPage, setTargetAnalysisPage, setCurrentTab } =
    useGlobal();

  const navigate = useNavigate();
  const { toggleTheme } = useContext(ThemeContext);

  useEffect(() => {
    setCurrentTab("analysis");
    toggleTheme("analysis");
    if (
      targetAnalysisPage === "overview" ||
      targetAnalysisPage === "matches" ||
      targetAnalysisPage === "stats"
    ) {
    } else {
      setTargetAnalysisPage("overview");
    }
  }, []);
  const { teamNumber, eventCode } = useParams();

  const handlePageChange = (type) => {
    setTargetAnalysisPage(type);
  };
  return (
    <Box>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "left",
              pb: 2,
              pl: 2,
            }}
          >
            <Typography
              sx={{ cursor: "pointer" }}
              onClick={() => navigate(`/analysis/team/${teamNumber}`)}
            >
              <u>Go To Team Page</u>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "right",
              pb: 2,
              pr: 2,
            }}
          >
            <Typography
              sx={{ cursor: "pointer" }}
              onClick={() => navigate(`/analysis/event/${eventCode}`)}
            >
              <u>Go To Event Page</u>
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pb: 2,
          }}
        >
          <QuickSearch />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              pb: 2,
            }}
          >
            <ButtonGroup
              variant="contained"
              sx={{
                width: "100%",
                aspectRatio: "9 / 1",
                minHeight: "70px",
                borderRadius: 4,
              }}
            >
              <Button
                sx={{
                  width: "100%",
                  color: "#fff",
                  opacity: targetAnalysisPage == "overview" ? 1 : 0.5,
                  fontSize: { xs: "4vw", sm: "2.5vw", md: "2vw", lg: "1.5vw" },
                  borderRadius: 4,
                  textAlign: "center",
                }}
                onClick={() => handlePageChange("overview")}
              >
                <b>Overview</b>
              </Button>
              <Button
                sx={{
                  width: "100%",
                  color: "#fff",
                  opacity: targetAnalysisPage == "stats" ? 1 : 0.5,
                  fontSize: { xs: "4vw", sm: "2.5vw", md: "2vw", lg: "1.5vw" },
                  borderRadius: 4,
                  textAlign: "center",
                }}
                onClick={() => handlePageChange("stats")}
              >
                <b>Statistics</b>
              </Button>
              <Button
                sx={{
                  width: "100%",
                  color: "#fff",
                  opacity: targetAnalysisPage == "matches" ? 1 : 0.5,
                  fontSize: { xs: "4vw", sm: "2.5vw", md: "2vw", lg: "1.5vw" },
                  borderRadius: 4,
                  textAlign: "center",
                }}
                onClick={() => handlePageChange("matches")}
              >
                <b>Matches</b>
              </Button>
            </ButtonGroup>
          </Box>
        </Grid>
        <Grid item xs={0} sm={2}></Grid>
        {targetAnalysisPage === "overview" && (
          <OverviewPage team={teamNumber} event={eventCode} />
        )}
        {targetAnalysisPage === "stats" && (
          <StatisticsPage team={teamNumber} event={eventCode} user={user} />
        )}
        {targetAnalysisPage === "matches" && (
          <MatchesPage team={teamNumber} event={eventCode} />
        )}
      </Grid>
    </Box>
  );
}
